module.exports = __webpack_public_path__ + "static/media/2015-decisiones.bb431211.pdf";